// Thought-quote spread on the home page: lazy-load card images via
// IntersectionObserver and handle image-download-with-text-overlay.
// Re-initializes on both initial load and router `page:load` so images that
// arrive via PJAX navigation still get their `src` set (inline scripts from
// fetched pages never execute).

function guideSlug() {
  try { return JSON.parse(document.body.dataset.brand || '{}').guide.slug || ''; } catch (e) { return ''; }
}

function initThoughtSection() {
  const cards = document.querySelectorAll('.thought-quote-card');
  if (!cards.length) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const img = entry.target.querySelector('img');
        if (img && img.dataset.src) {
          img.addEventListener('load', function () {
            img.classList.add('is-loaded');
          }, { once: true });
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '800px' });

  cards.forEach(function (c) { observer.observe(c); });

  document.querySelectorAll('.thought-quote-card__download').forEach(function (btn) {
    if (btn._thoughtDownloadReady) return;
    btn._thoughtDownloadReady = true;

    // Share on touch devices (mobile/PWA) where the native sheet can carry the
    // image; keep the download elsewhere — desktop Chrome exposes navigator.share
    // too, so a touch check is the reliable discriminator.
    const canShareFiles = typeof navigator !== 'undefined'
      && typeof navigator.share === 'function'
      && typeof navigator.canShare === 'function'
      && document.documentElement.dataset.input === 'touch';
    btn._canShareFiles = canShareFiles;
    if (canShareFiles) {
      btn.classList.add('is-share');
      btn.setAttribute('aria-label', 'Share quote image');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const card = this.closest('.thought-quote-card');
      const img = card && card.querySelector('.thought-quote-card__img');
      if (!img) return;
      const lines = Array.from(card.querySelectorAll('.thought-quote-card__text > span'));
      const domainEl = card.querySelector('.thought-quote-card__domain');

      const idx = this.getAttribute('data-index');
      const num = String(parseInt(idx, 10) + 1).padStart(2, '0');
      const c = document.createElement('canvas');
      const ctx = c.getContext('2d');
      const w = img.naturalWidth || 1080, h = img.naturalHeight || 1350;
      c.width = w; c.height = h;

      ctx.drawImage(img, 0, 0, w, h);

      ctx.fillStyle = 'rgba(0,0,0,0.35)';
      ctx.fillRect(0, 0, w, h);

      const badgeSize = Math.round(w * 0.022);
      ctx.font = '400 ' + badgeSize + 'px Figtree, system-ui, sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.shadowColor = 'rgba(0,0,0,0.6)';
      ctx.shadowBlur = 10;
      ctx.fillStyle = '#a1d171';
      ctx.fillText(num, Math.round(w * 0.035), Math.round(h * 0.035));
      ctx.shadowBlur = 0;

      const fontSize = Math.round(w * 0.07);
      ctx.font = '600 ' + fontSize + 'px Figtree, system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const lineH = fontSize * 1.25;
      const totalTextH = lines.length * lineH;
      const startY = (h - totalTextH) / 2;

      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 10;
      lines.forEach(function (span, i) {
        ctx.fillStyle = '#fff';
        ctx.fillText(span.textContent.trim(), w / 2, startY + i * lineH);
      });
      ctx.shadowBlur = 0;

      if (domainEl) {
        const domainSize = Math.round(w * 0.022);
        ctx.font = '400 ' + domainSize + 'px Figtree, system-ui, sans-serif';
        ctx.shadowColor = 'rgba(0,0,0,0.6)';
        ctx.shadowBlur = 10;
        ctx.fillStyle = '#a1d171';
        ctx.fillText(domainEl.textContent.trim(), w / 2, h - Math.round(h * 0.055));
        ctx.shadowBlur = 0;
      }

      c.toBlob(function (blob) {
        const file = new File([blob], guideSlug() + '-quote-' + num + '.png', { type: 'image/png' });
        if (btn._canShareFiles && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file] }).catch(function () {});
          return;
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = guideSlug() + '-quote-' + num + '.png';
        a.click();
        URL.revokeObjectURL(url);
      }, 'image/png');
    });
  });
}

export function init() {
  initThoughtSection();
}

document.addEventListener('page:load', initThoughtSection);